import { useQuery } from '@tanstack/react-query'
import { usersApi } from '../../../api/users.api'
import { rolesApi } from '../../../api/roles.api'
import formStyles from '../../../components/ui/Form.module.css'

interface AssigneePickerProps {
  userIds: string[]
  roleIds: string[]
  onToggleUser: (id: string) => void
  onToggleRole: (id: string) => void
}

export function AssigneePicker({ userIds, roleIds, onToggleUser, onToggleRole }: AssigneePickerProps) {
  const usersQuery = useQuery({ queryKey: ['users', { pageSize: 100 }], queryFn: async () => (await usersApi.list({ pageSize: 100 })).data })
  const rolesQuery = useQuery({ queryKey: ['roles'], queryFn: async () => (await rolesApi.list()).data })

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
      <div>
        <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)', fontWeight: 600, marginBottom: 4 }}>BENUTZER</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-2)' }}>
          {usersQuery.data?.map((user) => (
            <label key={user.id} className={formStyles.checkboxRow} style={{ border: '1px solid var(--surface-border)', borderRadius: 'var(--radius-md)', padding: '4px 10px' }}>
              <input type="checkbox" checked={userIds.includes(user.id)} onChange={() => onToggleUser(user.id)} />
              {user.displayName}
            </label>
          ))}
        </div>
      </div>
      <div>
        <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)', fontWeight: 600, marginBottom: 4 }}>ROLLEN</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-2)' }}>
          {rolesQuery.data?.map((role) => (
            <label key={role.id} className={formStyles.checkboxRow} style={{ border: '1px solid var(--surface-border)', borderRadius: 'var(--radius-md)', padding: '4px 10px' }}>
              <input type="checkbox" checked={roleIds.includes(role.id)} onChange={() => onToggleRole(role.id)} />
              {role.name}
            </label>
          ))}
        </div>
      </div>
    </div>
  )
}
